"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditAd = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reduxConnect = require("redux-connect");

var _reduxForm = require("redux-form");

var _reactRouterRedux = require("react-router-redux");

var _ads = require("../../redux/modules/ads");

var _projects = require("../../redux/modules/projects");

var _adFormValidator = require("./adFormValidator");

var _adFormValidator2 = _interopRequireDefault(_adFormValidator);

var _AdForm = require("../../components/ads/AdForm");

var _AdForm2 = _interopRequireDefault(_AdForm);

var _AdSuccessPanel = require("../../components/ads/AdSuccessPanel");

var _AdSuccessPanel2 = _interopRequireDefault(_AdSuccessPanel);

var _SendInvitationsModal = require("../../components/modal/SendInvitationsModal");

var _SendInvitationsModal2 = _interopRequireDefault(_SendInvitationsModal);

var _DriversList = require("../../components/projects/DriversList");

var _DriversList2 = _interopRequireDefault(_DriversList);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _license = require("../../redux/modules/license");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditAd = exports.EditAd = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EditAd, _Component);

  function EditAd() {
    (0, _classCallCheck3.default)(this, EditAd);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EditAd.__proto__ || (0, _getPrototypeOf2.default)(EditAd)).call(this));

    _this.updateAd = function (formData) {
      var _this$props = _this.props,
          routeParams = _this$props.routeParams,
          updateAd = _this$props.updateAd;

      var adId = parseInt(routeParams.adId, 10);
      updateAd(adId, formData);
    };

    _this.toggleSendInvitationsModal = function () {
      _this.setState({
        showSendInvitationsModal: !_this.state.showSendInvitationsModal
      });
    };

    _this.closeSendInvitationsModal = function () {
      _this.setState({ showSendInvitationsModal: false });
    };

    _this.openSendInvitationsModal = function () {
      _this.setState({ showSendInvitationsModal: true });
    };

    _this.state = {
      messageResponseText: "",
      showEditAdDriversModal: false,
      showSendInvitationsModal: false,
      projectId: 0,
      adId: 0,
      isProjectAd: false
    };
    _this.removeDriver = _this.removeDriver.bind(_this);
    _this.addDriver = _this.addDriver.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EditAd, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.projects.addDriverToAdSuccess) {
        if (this.props.projects.addedDrivers !== prevProps.projects.addedDrivers) {
          console.info("addDriverToAdSuccess", this.props.projects.addedDrivers);
          this.openSendInvitationsModal();
        }
      }
      //
      if (this.props.ads.sendAdMessageResponse) {
        if (this.props.ads.sendAdMessageResponse !== prevProps.ads.sendAdMessageResponse) {
          console.info("sendAdMessageResponse", this.props.ads.sendAdMessageResponse);
          this.setState({
            messageResponseText: this.props.ads.sendAdMessageResponse
          });
        }
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var user = this.props.user;
      var adId = this.props.params.adId;


      var userCompanyId = 0;
      var data = {};

      if (user) {
        userCompanyId = Number(user.company_id);
      }
      if (userCompanyId > 0 && this) {
        data.company_id = userCompanyId;
        data.ad_id = Number(adId);
        this.props.getAllDriversByProject(data);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props$params = this.props.params,
          adId = _props$params.adId,
          projectId = _props$params.projectId;

      if (projectId > 0) {
        this.setState({
          isProjectAd: true
        });
        var test = this.props.projectAdGetDrivers(adId);
      }
      var _props = this.props,
          ads = _props.ads.ads,
          fields = _props.fields;

      var ad = ads.find(function (ad) {
        return ad.id === parseInt(adId, 10);
      });
      this.setState({
        adId: parseInt(adId, 10)
      });
      if (projectId > 0) {
        this.setState({
          projectId: parseInt(projectId, 10)
        });
      }
      var adType = "public_Ad";
      (0, _keys2.default)(ad).forEach(function (key) {
        if (fields[key] && ad[key]) {
          fields[key].onChange(ad[key]);
        }
      });
      if (ad.visibility > 0) {
        adType = "private_Ad";
      }
      fields.ad_visibility.onChange(adType);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "J\xE4t\xE4 ilmoitus" }),
        this.defineContent()
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      var _state = this.state,
          isProjectAd = _state.isProjectAd,
          showSendInvitationsModal = _state.showSendInvitationsModal;
      var _props2 = this.props,
          project = _props2.project,
          updateProjectDriverByEmail = _props2.updateProjectDriverByEmail,
          sendAdMessage = _props2.sendAdMessage;
      var ads = this.props.ads.ads;
      var _props$params2 = this.props.params,
          adId = _props$params2.adId,
          projectId = _props$params2.projectId;

      var ad = ads.find(function (ad) {
        return ad.id === parseInt(adId, 10);
      });
      var validUntil = ad.validity_duration;
      var deliveryStartDate = ad.delivery_start_date || (0, _moment2.default)();
      var deliveryEndDate = ad.delivery_end_date || (0, _moment2.default)();

      if (this.props.ads.updateAdSuccess) {
        var transfer_request = this.props.fields.transfer_request;
        var ad_type = this.props.fields.ad_type;

        return _react2.default.createElement(_AdSuccessPanel2.default, {
          editing: false,
          transferRequestSent: !!transfer_request.value,
          pushRoute: this.props.pushRoute,
          resetState: this.props.resetUpdateAd,
          supplierAd: ad_type.value === "supplierAd",
          user: this.props.user,
          ad: ad
        });
      }

      return _react2.default.createElement(
        "div",
        null,
        isProjectAd ? _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h2" },
            project.business_name,
            ": ",
            project.name
          )
        ) : "",
        _react2.default.createElement(_AdForm2.default, (0, _extends3.default)({
          validUntil: validUntil,
          deliveryStartDate: deliveryStartDate,
          deliveryEndDate: deliveryEndDate,
          editing: true,
          fields: this.props.fields,
          soilTypes: this.props.ads.soilTypes,
          submitAd: this.updateAd,
          loading: this.props.ads.updateAdLoading || false,
          isProjectAd: isProjectAd
        }, this.props)),
        this.renderErrorMessage(),
        isProjectAd ? _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "h2",
            { className: "h4 form-title" },
            "Yrityksen kuljettajat "
          ),
          this.state.messageResponseText,
          // this.props.license.allDriverLicenses && this.props.projectAdDrivers &&
          _react2.default.createElement(_DriversList2.default, {
            adDriversList: this.props.projectAdDrivers,
            licensedDriversList: this.props.license.allDriverLicenses,
            updateDriverByEmail: updateProjectDriverByEmail,
            projectId: this.state.projectId,
            removeDriver: this.removeDriver,
            addDriver: this.addDriver
          }),
          _react2.default.createElement(_SendInvitationsModal2.default, {
            isShowingModal: showSendInvitationsModal,
            data: this.props.projects.addedDrivers,
            sendAdMessage: sendAdMessage,
            handleClose: this.toggleSendInvitationsModal })
        ) : ""
      );
    }
  }, {
    key: "removeDriver",
    value: function removeDriver(data) {
      // console.info('REMOVE DRIVER', data)
      // removeDriverFromAd
      var dataToSent = {
        useNewVersion: true,
        user_id: data.user_id,
        project_id: this.state.projectId,
        ad_id: this.state.adId
      };

      var removeDriverFromAd = this.props.removeDriverFromAd;

      removeDriverFromAd(dataToSent);
    }
  }, {
    key: "addDriver",
    value: function addDriver(data) {
      // console.info('ADD DRIVER', data)
      var dataToSent = {
        useNewVersion: true,
        user_id: data.user_id,
        project_id: this.state.projectId,
        email: data.email,
        ad_id: this.state.adId,
        phone: data.phone
      };
      // console.info('data to sent', dataToSent)
      var addDriverToAd = this.props.addDriverToAd;

      addDriverToAd(dataToSent);
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var createAdError = this.props.ads.createAdError;


      if (createAdError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-md-6 col-md-offset-6" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            "Ilmoituksen p\xE4ivitt\xE4misess\xE4 tapahtui virhe. Yrit\xE4 my\xF6hemmin uudelleen."
          )
        );
      }
    }
  }]);
  return EditAd;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  values: _react.PropTypes.object.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object.isRequired,
  ads: _react.PropTypes.object.isRequired,
  company: _react.PropTypes.object,
  handleSubmit: _react.PropTypes.func.isRequired,
  resetUpdateAd: _react.PropTypes.func.isRequired,
  updateAd: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  projectAdGetDrivers: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object.isRequired,
  projectUsers: _react.PropTypes.array,
  projectAdDrivers: _react.PropTypes.array,
  project: _react.PropTypes.object,
  projects: _react.PropTypes.object
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        _ref$params = _ref.params,
        projectId = _ref$params.projectId,
        adId = _ref$params.adId;

    var promises = [];
    promises.push(dispatch((0, _ads.loadAd)(adId)));
    if (projectId > 0) {
      promises.push(dispatch((0, _projects.loadProject)(projectId)));
      promises.push(dispatch((0, _projects.loadProjectUsers)(projectId)));
      promises.push(dispatch((0, _projects.projectAdGetDrivers)(adId)));
    }
    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    company: state.company.company,
    ads: state.ads,
    project: state.projects.project,
    projects: state.projects,
    projectUsers: state.projects.projectUsers,
    projectAdDrivers: state.projects.projectAdDrivers,
    license: state.license
  };
}, {
  loadProject: _projects.loadProject,
  pushRoute: _reactRouterRedux.push,
  resetUpdateAd: _ads.resetUpdateAd,
  updateAd: _ads.updateAd,
  loadProjectUsers: _projects.loadProjectUsers,
  addDriverToAd: _projects.addDriverToAd,
  removeDriverFromAd: _projects.removeDriverFromAd,
  projectAdGetDrivers: _projects.projectAdGetDrivers,
  updateProjectDriverByEmail: _projects.updateProjectDriverByEmail,
  getAllDriversByProject: _license.getAllDriversByProject,
  sendAdMessage: _ads.sendAdMessage,
  sendAdMessageResponse: _ads.sendAdMessageResponse
})((0, _reduxForm.reduxForm)({
  form: "createAd",
  fields: ["construction_site_id", "project_id", "ad_type", "builder", "contractor", "latitude", "longitude", "address", "postal_area", "postal_code", "contact_person_name", "contact_person_phone", "contact_person_email", "soil_type_id", "soil_amount", "soil_description", "price", "delivery_time", "delivery_start_date", "delivery_end_date", "validity_duration", "end_date", "notes", "transfer_request", "activated", "ad_visibility", "visibility,"],
  validate: _adFormValidator2.default,
  initialValues: {
    latitude: 0.0,
    longitude: 0.0
  }
})(EditAd)));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Ads/EditAd.js
 ** module id = 1206
 ** module chunks = 0
 **/